"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  cargoTracking: {
    title: 'Cargo Tracking',
    blNo: 'B/L No.',
    containerNo: 'Container No.',
    pickUp: 'Outbound <br>  Pickup',
    outboundCY: 'Outbound <br> In&nbsp;CY',
    departPOL: 'Vsl&nbsp;Depart <br> POL',
    berthPOD: 'Vsl&nbsp;Berth <br> POD',
    inboundCY: 'Inbound  <br> In&nbsp;CY',
    release: 'Release',
    inboundDelivery: 'Inbound <br> Delivery',
    emptyContainer: 'Empty <br> Container',
    receivedOrder: 'Received <br> Order',
    releaseBox: 'Release <br> Container',
    sendCar: 'Send <br> Truck',
    ReceivedBox: 'Received <br> Container',
    arriveFactory: 'Arrive <br> Yard',
    leaveFactory: 'Leave <br> Yard',
    ReturnBox: 'Return <br> Container',
    position: 'Position',
    track: 'Track',
    tips_1: 'Black font：Estimated time |',
    tips_2: ' Red font： Actual time'
  }
};